<template>
	<div class="mt-2 pt-2 pt-lg-1 mt-lg-1">
		<vue-good-table
			:columns="columns"
			:rows="rows"
			theme="black-rhino"
			:line-numbers="true"
			:rtl="true"
			row-style-class="rowStyleClassFn"
			@on-row-click="onRowClick"
			:pagination-options="{
				enabled: true,
				mode: 'pages',
				perPage: 10,
				position: 'bottom',
				perPageDropdown: [5, 10, 15, 20],
				dropdownAllowAll: true,
				setCurrentPage: 1,
				nextLabel: '',
				prevLabel: '',
				rowsPerPageLabel: 'تعداد در هر صفحه',
				ofLabel: 'از',
				pageLabel: 'صفحه', // for 'pages' mode
				allLabel: 'همه',
			}"
			class="mt-5"
		>
			<template slot="table-row" slot-scope="props">
				<span v-if="props.column.field == 'status'">
					<span v-html="statusFn(props.row.status)"> </span>
				</span>
				<span v-else-if="props.column.field == 'level'">
					<span v-html="levelFn(props.row.level)"> </span>
				</span>
				<span v-else-if="props.column.field == 'contract_status'">
					<span v-html="statusShow(props.row.contract_status)"> </span>
				</span>
				<span v-else>
					{{ props.formattedRow[props.column.field] }}
				</span>

				<!-- <span v-if="props.column.field == 'btn'">
					<span v-html="actionBtn(props.row.originalIndex)"> </span>
				</span> -->
			</template>
			<div slot="table-actions" class="justify-content-end">
				<button
					type="button"
					class="btn btn-bg--primary btn-size--sm btn-hover--3d ml-3 mr-auto"
					data-toggle="modal"
					data-target="#addCustomer"
				>
					<span class="font-size--13 font-w--300"> افزودن مشتری</span>
				</button>

				<!-- <router-link
          to="/supplier/customer-signup"
          class="btn btn-bg--primary btn-size--sm btn-hover--3d ml-3 mr-auto"
        >
          <span class="font-size--13 font-w--300"> ثبت نام مشتری</span>
        </router-link> -->
			</div>
		</vue-good-table>

		<!-- --------------------------------------------modal-------------------------------------- -->

			<div
			class="modal fade"
			id="addCustomer"
			tabindex="-1"
			role="dialog"
			aria-labelledby="addCustomerLable"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<!-- -----header-------- -->
					<div class="modal-header bg-color--dark--2">
						<h5 class="modal-title text-white" id="addCustomerLable">
							افزودن مشتری جدید
						</h5>
						<button
							type="button"
							class="close ml-10 mr-0"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true" class="text-white">&times;</span>
						</button>
					</div>
					<!-- --------body---------- -->
					<div class="modal-body bg-color--light--2">
						<form>
							<div class="form-group">
								<label for="recipient-name" class="col-form-label">{{
									$t("register.melliCode")
								}}</label>
								<input
									type="number"
									class="form-control"
									id="melli_code"
									v-model="melli_code"
								/>
							</div>
						</form>
					</div>
					<!-- --------footer-------- -->
					<div class="modal-footer bg-color--dark--2">
						<button
							type="button"
							class="btn btn-bg--primary mr-auto"
							@click.prevent="addCustomer"
						>
							افزودن
						</button>
						<button
							type="button"
							class="btn btn-bg--darkblue"
							data-dismiss="modal"
						>
							بستن
						</button>
					</div>
				</div>
			</div>
		</div>

		
        
		<!-- ===================================== calculatore Modal ================================ -->

		<!-- ========================================================================================= -->
	</div>
	
</template>

<script>

export default {
	data() {
		return {
			melli_code: "",
			// net_amount: "",
			// number_of_instalment: "",
			// downpayment: 20000000,
			// instalment_amount: 10000000,
			columns: [
				//   id
				{
					label: "آیدی",
					field: "id",
					hidden: true,
				},

				// first_name
				{
					label: this.$t("supplier.first_name"),
					field: "first_name",
					filterable: true,
					tdClass: "text-center",
					thClass: "text-center",
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: "جست و جو بر اساس نام", // placeholder for filter input
						filterFn: this.columnFilterFn, //custom filter function that
						trigger: "", //only trigger on enter not on keyup
					},
				},

				// last_name
				{
					label: this.$t("supplier.last_name"),
					field: "last_name",
					filterable: true,
					tdClass: "text-center",
					thClass: "text-center",
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: " جست و جو بر اساس نام خانوادگی", // placeholder for filter input
						//filterDropdownItems: ['Blue', 'Red', 'Yellow'], // dropdown (with selected values) instead of text input
						filterFn: this.columnFilterFn, //custom filter function that
						trigger: "", //only trigger on enter not on keyup
					},
				},

				// melli_code
				{
					label: this.$t("supplier.melli_code"),
					field: "melli_code",
					type: "number",
					tdClass: "text-center",
					thClass: "text-center",
					filterable: true,
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: "جست و جو بر اساس کد ملی", // placeholder for filter input
						//filterDropdownItems: ['Blue', 'Red', 'Yellow'], // dropdown (with selected values) instead of text input
						filterFn: this.columnFilterFn, //custom filter function that
						trigger: "", //only trigger on enter not on keyup
					},
				},

				// mobile_number
				{
					label: this.$t("supplier.mobile_number"),
					field: "mobile_number",
					type: "number",
					tdClass: "text-center",
					thClass: "text-center",
					filterable: true,
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: "جست و جو بر اساس شماره همراه", // placeholder for filter input
						//filterDropdownItems: ['Blue', 'Red', 'Yellow'], // dropdown (with selected values) instead of text input
						filterFn: this.filterFn, //custom filter function that
						trigger: "", //only trigger on enter not on keyup
					},
				},

				// level
				{
					label: this.$t("supplier.level"),
					field: "level",
					tdClass: "text-center",
					thClass: "text-center",
					filterable: true,
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: "جست و جو سطح تسهیلات", // placeholder for filter input
						filterDropdownItems: [
							{ value: "1", text: "سطح ۱" },
							{ value: "2", text: "سطح ۲" },
							{ value: "3", text: "سطح ۳" },
						],
						trigger: "", //only trigger on enter not on keyup
					},
				},

				// status
				{
					label: this.$t("supplier.status"),
					field: "status",
					type: "string",
					tdClass: "text-center",
					thClass: "text-center",
					width: "80px",
					filterable: true,
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: "جست و جو وضعیت", // placeholder for filter input
						filterDropdownItems: [
							{value:"",text:"همه"},
							{ value: "00", text: "در انتظار تکمیل مدارک" },
							{ value: "0", text: "در حال بررسی" },
							{ value: "5", text: "نقص مدارک" },
							{ value: "1", text: "تایید شده" },
							{ value: "3", text: "تائید مشروط" },
							{ value: "2", text: "رد شده" },
							
							{ value: "4", text: "انصراف متقاضی" },
							
							{ value: "6", text: "انقضای رتبه اعتباری" },
						],
						trigger: "", //only trigger on enter not on keyup
					},
				},

				// credit_rank
				{
					label: this.$t("supplier.Description"),
					field: "credit_rank",
					filterable: true,
					tdClass: "text-center",
					thClass: "text-center",
				},

				// contract_status
				{
					label: this.$t("supplier.contract_status"),
					field: "contract_status",
					filterable: true,
					tdClass: "text-center",
					thClass: "text-center",
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: "فیلتر ", // placeholder for filter input
						filterDropdownItems: [
							{ value: "9", text: "بدون قرارداد" },
							{ value: "0", text: "تایید دریافت پیش پرداخت" },
							{ value: "1", text: " در حال عقد قراداد" },
							{ value: "2", text: "تایید قرارداد و ارسال کالا" },
							{ value: "3", text: "تسویه با فروشگاه" },
							{ value: "4", text: "پرداخت اقساط توسط متقاضی" },
							{ value: "5", text: "تسویه متقاضی و تحویل مدارک" },
							{ value: "6", text: "نکول قطعی" },
							{ value: "7", text: "انصراف متقاضی" },
							// { value: "8", text: "در انتظار تایید فروشگاه" },
						],
						trigger: "", //only trigger on enter not on keyup
					},
				},

				// phone_number
				{
					label: this.$t("supplier.phone_number"),
					field: "phone_number",
					type: "number",
					tdClass: "text-center",
					thClass: "text-center",
					filterable: true,
				},

				// job
				{
					label: this.$t("supplier.job"),
					field: "job",
					tdClass: "text-center",
					thClass: "text-center",
					filterable: true,
				},

				// address
				{
					label: this.$t("supplier.address"),
					field: "address",
					html: true,
					thClass: "text-center",
				},
			],
			rows: [],
		};
	},
	mounted() {
		this.getSupplierCustomers();
		this.getSupplierInfo();
	},

	methods: {
		closeModal()
		{
			let element = document.getElementsByClassName("modal-backdrop")[0]
			element.classList.remove("modal-backdrop")
			document.getElementById("addCustomer").classList.remove("show")
		},
		filterFn: function(data, filterString) {
			var x = parseInt(filterString);

			console.log("x: ", x);
			return data >= x - 1 && data <= x + 1;
		},
		filterNumFn: function(data, filterString) {
			var x = parseInt(filterString);
			return data >= x - 1 && data <= x + 1;
		},
		statusFn: function(st) {
			if (st === "00") {
				return '<span class="badge badge-warning" style="height:25px;text-align:center"><b>در انتظار تکمیل مدارک</b></span>';
			}
			if (st === "0") {
				return '<span class="badge badge-warning" style="height:25px;text-align:center"><b>در حال بررسی</b></span>';
			}
			if (st === "1") {
				return '<span class="badge badge-success" style="height:25px;"><b>تایید شده</b></span>';
			}
			if (st === "2") {
				return '<span class="badge badge-danger" style="height:25px;"><b> رد شده</b></span>';
			}
			if (st === "3") {
				return '<span class="badge badge-warning" style="height:25px;"><b> تائید مشروط</b></span>';
			}
			if (st === "4") {
				return '<span class="badge badge-danger" style="height:25px;"><b>انصراف متقاضی</b></span>';
			}
			if (st === "5") {
				return '<span class="badge badge-danger" style="height:25px;"><b>نقص مدارک</b></span>';
			}
			if (st === "6") {
				return '<span class="badge badge-danger" style="height:25px;"><b>انقضای رتبه اعتباری</b></span>';
			}
			return;
		},
		levelFn: function(st) {
			if (st === "1") {
				return '<span class="badge badge-info" style="height:25px;text-align:center"><b>سطح ۱</b></span>';
			}
			if (st === "2") {
				return '<span class="badge badge-secondary" style="height:25px;"><b>سطح ۲</b></span>';
			}
			if (st === "3") {
				return '<span class="badge badge-dark" style="height:25px;"><b> سطح ۳</b></span>';
			}
			return;
		},
		statusShow(st) {
			if (st === "0") {
				return '<span class="badge badge-danger" style="height:25px;text-align:center"><b>تایید دیافت پیش پرداخت </b></span>';
			}
			if (st === "1") {
				return '<span class="badge badge-info" style="height:25px;"><b>در حال عقد قراداد</b></span>';
			}
			if (st === "2") {
				return '<span class="badge badge-success" style="height:25px;"><b> تایید قرارداد و ارسال کالا</b></span>';
			}
			if (st === "3") {
				return '<span class="badge badge-info" style="height:25px;text-align:center"><b>تسویه با فروشگاه</b></span>';
			}
			if (st === "4") {
				return '<span class="badge badge-info" style="height:25px;"><b> پرداخت اقساط توسط متقاضی</b></span>';
			}
			if (st === "5") {
				return '<span class="badge badge-success" style="height:25px;"><b> تسویه متقاضی و تحویل مدارک</b></span>';
			}
			if (st === "6") {
				return '<span class="badge badge-warning" style="height:25px;"><b> نکول قطعی</b></span>';
			}
			if (st === "7") {
				return '<span class="badge badge-danger" style="height:25px;"><b>انصراف متقاضی</b></span>';
			}
			// if (st === "8") {
			// 	return '<span class="badge badge-warning" style="height:25px;"><b>در انتظار تایید فروشگاه</b></span>';
			// }
			if (st === "9") {
				return '<span class="badge badge-danger" style="height:25px;"><b>بدون قرارداد</b></span>';
			}
		},
		getSupplierInfo() {
			this.$store
				.dispatch("getSupplierInfo")
				.then((resp) => {
					console.log(resp);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getSupplierCustomers() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getSupplierCustomers")
				.then((resp) => {
					console.log(resp);
					let customers = resp.body;
					for (let i = 0; i < customers.length; i++) {
						let customer = {};
						customer.contract_status = customers[i].contract_status;
						customer.credit_rank = customers[i].credit_rank;
						customer.id = customers[i].id;
						customer.job = customers[i].job;
						customer.level = customers[i].level;
						customer.status = customers[i].status;
						customer.suretys = customers[i].suretys;
						customer.job_class = customers[i].job_class;
						customer.postal_code = customers[i].postal_code;

						customer.first_name = customers[i].first_name;
						customer.last_name = customers[i].last_name;
						customer.melli_code = customers[i].melli_code;
						customer.mobile_number = customers[i].mobile_number;
						customer.phone_number = customers[i].phone_number;
						customer.workplace_number = customers[i].workplace_number;
						customer.father_name = customers[i].father_name;
						customer.province = customers[i].province;
						customer.city = customers[i].city;
						customer.address = customers[i].address;

						this.rows.push(customer);
					}

					load.hide();
				})
				.catch((err) => {
					console.log(err);
					load.hide();
					//this.$router.push("/login-supplier");
				});
		},

		onRowClick(params) {
			localStorage.setItem("SupplierCustomerId",params.row.id)
			this.$router.push("/supplier/customers/" + params.row.id);
			
		},
		addCustomer() {
			
			let customer_data = {
				customerMellicode: this.melli_code,
			};
			this.$store
				.dispatch("addCustomer", customer_data)
				.then((resp) => {
					console.log(resp);
					const firstName = resp.body.data.first_name;
					const lastName = resp.body.data.last_name;
					this.$noty.success(
						firstName +
							"&nbsp;" +
							lastName +
							" &nbsp;" +
							" به مشتریان شما اضافه شد ",
					);
					this.closeModal()
					this.getSupplierCustomers();
					
				})
				.catch((err) => {
					console.log(err);
					const errMsg = err.body.Error;
					this.$noty.error(errMsg);
				});
		},
	},

	components: {
		// VueNumeric,
		
	},
};
</script>

<style>
.green {
	background-color: green;
}

.red {
	background-color: red;
}
</style>
